import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import 'leaflet/dist/leaflet.css';
import { TripCommand } from '../commands/TripCommand';
import { Container, Col, Row, Button, Spinner } from 'react-bootstrap';
import { strings } from '../../resources/strings';
import { LineInfoMap } from './LineInfoMap';


export class LineInfo extends Component {
    static contextTypes = {
        getLogo: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            commands: {
                trips: new TripCommand()
            },
            trip: undefined,
            selectedTripPassing: undefined,
            isLoadingTrip: true,
            displayTripInfo: true,
            displayMap: true
        }
    }

    componentDidMount() {
        //Set function to handle when window is resized
        window.onresize = () => this.resize();

        this.getTrip();
    }

    componentWillUnmount() {
        window.onresize = () => { };
    }

    resize() {
        if (window.innerWidth > 767) {
            this.setState({
                displayTripInfo: true,
                displayMap: true
            });
        } else {
            document.getElementById("line-info-show-stops-button").click();
        }
    }

    //TRIP
    getTrip() {
        const { commands } = this.state;
        const { passing, provider } = this.props;

        if (undefined !== passing) {
            if (passing.isRT) {
                commands.trips.getEstimatedTrip(provider, passing.lineId, passing.direction, passing.stopId, (r) => this.getTripSuccessCallback(r));
            } else {
                commands.trips.getTrip(passing.tripId, (r) => this.getTripSuccessCallback(r));
            }
        }
    }

    getTripSuccessCallback(result) {
        this.setState({
            trip: result,
            isLoadingTrip: false
        }, () => {
            //call resize function to check the current width, otherwise resizing the window is the only trigger;  
            this.resize();
        });
    }

    //HELPER FUNCTIONS

    handleSelectTripPassing(tripPassing) {
        this.setState({
            selectedTripPassing: tripPassing
        });
    }

    handleMoreSchedsClick() {
        const { trip } = this.state;
        const { passing, provider, onMoreSchedsClick } = this.props;
        onMoreSchedsClick({ trip: trip, passing: passing, provider: provider });
    }

    displayTripInfo() {
        this.setState({
            displayTripInfo: true,
            displayMap: false
        });
    }

    displayMap() {
        this.setState({
            displayTripInfo: false,
            displayMap: true
        });
    }

    //--------------
    renderProviderLogo(provider) {
        const { getLogo } = this.context;
        const imgUrl = getLogo(provider);

        if (null === imgUrl) {
            return null;
        }

        return (
            <img height="40px" src={imgUrl} alt={`${provider}`} />
        );
    }

    renderInfo() {
        const { trip, selectedTripPassing, displayTripInfo, displayMap } = this.state;
        const { passing } = this.props;

        if (displayTripInfo && displayMap) {
            return (
                <Row>
                    <Col sm={5} className="line-info-container-trip-col">
                        {this.renderTripHeader(trip)}
                        {this.renderTrip(trip)}
                    </Col>
                    <Col sm={7} className="line-info-container-map-col">
                        <LineInfoMap trip={trip} passing={passing} selectedTripPassing={selectedTripPassing} makeTooltipsPermanent={true} />
                    </Col>
                </Row>
            );
        } else {
            if (displayTripInfo) {
                return (
                    <Row>
                        <Col sm={12} className="line-info-container-trip-col">
                            {this.renderTripHeader(trip)}
                            {this.renderTrip(trip)}
                        </Col>
                    </Row>
                );
            } else {
                return (
                    <Row>
                        <Col sm={12} className="line-info-container-map-col">
                            {this.renderTripHeader(trip)}
                            <LineInfoMap trip={trip} passing={passing} selectedTripPassing={selectedTripPassing} makeTooltipsPermanent={true} />
                        </Col>
                    </Row>
                );
            }
        }
    }

    renderTripHeader(trip) {
        const { isLoadingTrip, displayMap, displayTripInfo } = this.state;
        const { onReturn } = this.props;

        if (undefined === trip || 0 === trip.passings.length) {
            return (
                <div className="line-info-header">
                    <div>
                        <Button className="line-info-back-button" variant="light" onClick={() => onReturn()}>
                            <div className={"icon-redo"} />
                        </Button>
                    </div>
                    <div className="line-info-panel-header text-align-center">
                        {isLoadingTrip ?
                            <Spinner animation="border" role="status" />
                            :
                            <span>{strings.noInfoToShow}</span>
                        }
                    </div>
                </div>
            );
        }

        const { passing, provider } = this.props;

        return (
            <div className="line-info-header">

                <Button className="line-info-back-button" variant="light" onClick={() => onReturn()}>
                    <div className={"icon-redo"} />
                </Button>
                <div className="line-info-small-screen-tabs">
                    <Button id="line-info-show-stops-button" className={`line-info-small-screen-tabs-link-button ${displayTripInfo ? "orange-text" : ""}`} variant="link" onClick={() => this.displayTripInfo()}>
                        {strings.showStops}
                    </Button>
                    <span className="orange-text">|</span>
                    <Button id="line-info-show-map-button" className={`line-info-small-screen-tabs-link-button ${displayMap ? "orange-text" : ""}`} variant="link" onClick={() => this.displayMap()}>
                        {strings.showMap}
                    </Button>
                </div>

                <div className="line-info-panel-header">
                    <div className="line-info-panel-header-provider-info">
                        {this.renderProviderLogo(provider)}
                        <div className="line-info-panel-header-trip-info">
                            <div><b>{passing.lineCode}</b> {passing.name}</div>
                            <div>{`${trip.passings[0].name} > ${trip.passings[trip.passings.length - 1].name}`}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderTrip(trip) {
        if (undefined === trip || 0 === trip.passings.length) {
            return null;
        }

        const { passing } = this.props;

        return (
            <div className="line-info-panel">
                <span className="line-info-stops-title">{strings.lineInfoStopsTitle}</span>

                <Container fluid className="line-info-passings-list">
                    {
                        trip.passings.map((tripPassing, index) =>

                            <Row key={`line-info-passing-${index}`} onClick={() => this.handleSelectTripPassing(tripPassing)}>
                                <Col xs={1}>
                                    <img src={passing.stopId === tripPassing.stopId ? "icons/highlightedMarker.png" : "icons/lineInfoMarker.png"} alt="" />
                                </Col>
                                <Col xs={9} className="d-flex justify-content-between">
                                    <div className="d-inline-block text-truncate">{tripPassing.name}</div>
                                    {this.renderMoreSchedsButton(passing.stopId === tripPassing.stopId)}
                                </Col>

                                <Col xs={2} className={passing.isRT ? "rt-passing-info" : ""}>
                                    {passing.isRT ? -1 === tripPassing.duration ? "" : `${tripPassing.duration}min` : tripPassing.formattedTimeStamp}
                                </Col>
                            </Row>
                        )
                    }
                </Container>
            </div>
        );
    }

    renderMoreSchedsButton(isSelectedStop) {
        if (isSelectedStop) {
            return (
                <div className="white-space-no-wrap orange-text" onClick={() => this.handleMoreSchedsClick()}>
                    {strings.lineInfoMoreScheds}
                </div>
            );
        }

        return null;
    }

    render() {
        return (
            <Container fluid className="line-info-container">
                {this.renderInfo()}
            </Container>
        );
    }
}
